import { useEffect, useState } from "react";

export const useVerifyIsMobile = (minWidth = 650) => {
  const [isMobile, setIsMobile] = useState(false);

  const verifyIsMobile = () => {
    window.innerWidth < minWidth ? setIsMobile(true) : setIsMobile(false);
  };

  useEffect(() => {
    window.innerWidth < minWidth && setIsMobile(true);
    window.addEventListener("resize", verifyIsMobile);

    return () => {
      window.removeEventListener("resize", verifyIsMobile);
    };
  }, []);

  return {isMobile}
};